
import orderUtil from "../../Utils/orderUtil.js";
const Css = {
  SelectLine(width, marginLeft){
    return {
      width: width + "px",
      height: orderUtil.canvasHeight + 'px',
      position: 'absolute',
      marginLeft: marginLeft + "px",
      marginTop: "46px",
      backgroundColor: "#fff",
      opacity: 0.15,
      filter: "alpha(opacity=15)",
      MozOpacity: 0.15,
    }
  },
  Menu(marginLeft){
    return {
      width: "60px",
      backgroundColor: "#444",
      borderRadius: "4px",
      marginTop: "100px",
      position: "absolute",
      marginLeft: marginLeft + "px",
      zIndex: "9"
    }
  },
  menuItem: {
    width: "60px",
    height: "29px",
    lineHeight: "29px",
    textAlign: "center",
    color: "#ccc",
    fontSize: "12px",
    cursor: "pointer",
    borderBottomWidth: "1px",
    borderBottomColor: "#666",
    borderBottomStyle: "solid",
  },
  menuItem2: {
    width: "60px",
    height: "29px",
    lineHeight: "29px",
    textAlign: "center",
    color: "#ccc",
    fontSize: "12px",
    cursor: "pointer"
  }
}

export default Css;